import {hasPremiumAccess} from './premiumAccess';
export const PREMIUM_VOICE_EFFECTS = [['premium-cyber','סייבר'],['premium-titan','טיטאן'],['premium-ghost','רוח רפאים'],['premium-crystal','קריסטל'],['premium-cosmic','קוסמי']];
export const isPremiumVoice = name => PREMIUM_VOICE_EFFECTS.some(([id])=>id===name);
export const VOICE_EFFECTS = [['natural',"טבעי"],['warm',"חם"],['radio',"רדיו"],['robot',"רובוט"],['echo',"הד"],...PREMIUM_VOICE_EFFECTS];

// One stable outgoing track: changing the sound never requires renegotiating a call.
export function createVoiceEffects(source,{onEffectChange=()=>{}}={}) {
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  if (!AudioContext || !source.getAudioTracks().length) throw new Error("אפקטים קוליים אינם זמינים בדפדפן הזה.");
  const context = new AudioContext();
  const input = context.createMediaStreamSource(source);
  const output = context.createMediaStreamDestination();
  const filter = context.createBiquadFilter();
  const ring = context.createGain();
  const oscillator = context.createOscillator();
  const modulation = context.createGain();
  const delay = context.createDelay(1);
  const wet = context.createGain();
  const secondDelay = context.createDelay(1);
  const secondWet = context.createGain();
  const limiter = context.createDynamicsCompressor();
  const nodes = [input,filter,ring,oscillator,modulation,delay,wet,secondDelay,secondWet,limiter];
  limiter.threshold.value = -12; limiter.ratio.value = 6;
  oscillator.frequency.value = 45; modulation.gain.value = .65;
  oscillator.connect(modulation); oscillator.start();
  limiter.connect(output);
  const stream = new MediaStream([...source.getVideoTracks(), ...output.stream.getAudioTracks()]);
  let stopped=false,currentEffect='natural';
  const setEffect = async name => {
    if(stopped)return;
    if(isPremiumVoice(name)&&!hasPremiumAccess())throw new Error('אפקט קולי זה זמין למנויי Premium בלבד.');
    if(!VOICE_EFFECTS.some(([id])=>id===name))name='natural';
    input.disconnect();filter.disconnect();ring.disconnect();delay.disconnect();wet.disconnect();secondDelay.disconnect();secondWet.disconnect();modulation.disconnect();
    ring.gain.value=1;oscillator.frequency.value=45;modulation.gain.value=.65;filter.gain.value=0;filter.Q.value=.7;
    if(name==='radio'||name==='warm') {
      filter.type=name==='radio'?'bandpass':'lowpass';
      filter.frequency.value=name==='radio'?1600:1100;filter.Q.value=name==='radio'?.8:.7;
      input.connect(filter);filter.connect(limiter);
    } else if(name==='robot') {
      ring.gain.value=.35;modulation.connect(ring.gain);input.connect(ring);ring.connect(limiter);
    } else if(name==='echo') {
      input.connect(limiter);input.connect(delay);delay.delayTime.value=.16;wet.gain.value=.22;
      delay.connect(wet);wet.connect(limiter);
    } else if(name==='premium-cyber') {
      filter.type='bandpass';filter.frequency.value=1800;filter.Q.value=.65;
      oscillator.frequency.value=82;modulation.gain.value=.45;ring.gain.value=.55;
      modulation.connect(ring.gain);input.connect(filter);filter.connect(ring);ring.connect(limiter);
    } else if(name==='premium-titan') {
      filter.type='lowshelf';filter.frequency.value=360;filter.gain.value=8;
      input.connect(filter);filter.connect(limiter);filter.connect(delay);
      delay.delayTime.value=.035;wet.gain.value=.2;delay.connect(wet);wet.connect(limiter);
    } else if(name==='premium-ghost') {
      filter.type='highpass';filter.frequency.value=480;input.connect(filter);filter.connect(limiter);
      filter.connect(delay);filter.connect(secondDelay);delay.delayTime.value=.12;secondDelay.delayTime.value=.26;
      wet.gain.value=.3;secondWet.gain.value=.18;delay.connect(wet);secondDelay.connect(secondWet);wet.connect(limiter);secondWet.connect(limiter);
    } else if(name==='premium-crystal') {
      input.connect(limiter);input.connect(delay);delay.delayTime.value=.025;
      oscillator.frequency.value=.8;modulation.gain.value=.004;modulation.connect(delay.delayTime);
      filter.type='highpass';filter.frequency.value=1200;delay.connect(filter);filter.connect(wet);wet.gain.value=.5;wet.connect(limiter);
    } else if(name==='premium-cosmic') {
      input.connect(limiter);input.connect(ring);ring.gain.value=.5;
      oscillator.frequency.value=28;modulation.gain.value=.45;modulation.connect(ring.gain);
      ring.connect(delay);delay.delayTime.value=.18;wet.gain.value=.38;delay.connect(wet);wet.connect(limiter);
    } else input.connect(limiter);
    currentEffect=name;onEffectChange(name);
    let timer;
    try {
      await Promise.race([context.resume(),new Promise((resolve,reject)=>{
        timer=setTimeout(()=>reject(new Error('הפעלת השמע נמשכה זמן רב מדי')),2000);
      })]);
    } finally {clearTimeout(timer);}
    if(context.state!=='running'&&!stopped)throw new Error("לחצו על בחירת הקול כדי להפעיל שמע.");
  };
  const entitlementTimer=setInterval(()=>{
    if(!stopped&&isPremiumVoice(currentEffect)&&!hasPremiumAccess())setEffect('natural').catch(()=>{});
  },1000);
  return {stream,setEffect,stop({keepSource=false}={}){if(stopped)return;stopped=true;clearInterval(entitlementTimer);oscillator.stop();nodes.forEach(node=>node.disconnect());output.stream.getTracks().forEach(track=>track.stop());if(!keepSource)source.getTracks().forEach(track=>track.stop());context.close().catch(()=>{});}};
}
